var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Cadastrante" } }),
      _c("div", [
        _vm.cadastrante.pessoa
          ? _c(
              "div",
              { staticClass: "pad5" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("p", [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getLabelCpfOrCnpj(
                                _vm.cadastrante.pessoa.isPessoaFisica
                              )
                            )
                          )
                        ]),
                        _c("span", [
                          _vm._v(
                            "  " +
                              _vm._s(_vm.getCpfOrCnpj(_vm.cadastrante.pessoa))
                          )
                        ])
                      ])
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("p", [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getLabelNomeOrRazaoSocial(
                                _vm.cadastrante.pessoa.isPessoaFisica
                              )
                            )
                          )
                        ]),
                        _c("span", [
                          _vm._v(
                            "  " +
                              _vm._s(
                                _vm.getNomeOrRazaoSocial(_vm.cadastrante.pessoa)
                              )
                          )
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _vm.cadastrante.pessoa.email
                        ? _c("p", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("E-mail:")
                            ]),
                            _c("span", [
                              _vm._v(
                                "  " + _vm._s(_vm.cadastrante.pessoa.email)
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _vm.cadastrante.pessoa.telefones &&
                      _vm.cadastrante.pessoa.telefones.length > 0
                        ? _c("p", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("Telefones:")
                            ]),
                            _c("span", [
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    _vm.getTelefones(
                                      _vm.cadastrante.pessoa.telefones
                                    )
                                  )
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _c("app-resumo-endereco", {
                  attrs: { endereco: _vm.cadastrante.pessoa.endereco }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-104ee07c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104ee07c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoCadastrante.vue
// module id = null
// module chunks = 